import { estacionWithIcon } from '../CatalogoProductInfo'
import {
  CategoriaVehiculo,
  CategoriaVehiculoEnum,
} from '../../../../../common/types/Vehiculo'
import CocheIcon from './assets/coche.svg'

export const getGalleryImages = (
  productImages:
    | { url: string; tipo: { tipo_imagen: string } | string }[]
    | undefined,
  imageType: string,
  defaultImage: string,
  minCount: number
): string[] => {
  const filterImagesByType = (
    images: { url: string; tipo: { tipo_imagen: string } | string }[],
    type: string
  ): string[] =>
    images
      .filter((img) => {
        // Check if tipo is from old models and neumaticos structure or new catalogo images structure
        if (typeof img.tipo === 'object') {
          return img.tipo.tipo_imagen === type
        }
        return img.tipo === type
      })
      .map((img) => img.url)

  const repeatImages = (images: string[], minCount: number): string[] => {
    if (images.length >= minCount) return images
    const repeated = []
    while (repeated.length < minCount) {
      repeated.push(...images)
    }
    return repeated.slice(0, minCount)
  }

  const images = productImages
    ? filterImagesByType(productImages, imageType)
    : []

  return repeatImages(images.length ? images : [defaultImage], minCount)
}

export async function loadEstacionesIcons(estaciones: estacionWithIcon[]) {
  const icons = await Promise.all(
    estaciones.map(async (estacion) => {
      if (estacion.icon) {
        try {
          const { ReactComponent } = await import(`./assets/${estacion.icon}`)
          return ReactComponent
        } catch (e) {
          console.error('Error loading icon:', estacion.icon, e)
          return null
        }
      }
      return null
    })
  )

  return icons.filter((icon) => icon !== null) as React.ElementType[]
}

const iconMap: Record<string, never> = {
  [CategoriaVehiculoEnum.COCHE]: CocheIcon,
  [CategoriaVehiculoEnum.MOTO]: CocheIcon,
}

export const loadCategoriaIcon = async (categoria: CategoriaVehiculo) => {
  try {
    if (!iconMap[categoria]) {
      throw new Error(`Icon not found for category: ${categoria}`)
    }

    return {
      name: categoria,
      icon: iconMap[categoria],
    }
  } catch (error) {
    console.error(`Error loading icon for type: ${categoria}`, error)
    return null
  }
}
